import clsx from 'clsx';
import { useRef } from 'react';
import type { JsonDataItem } from '../generic-types';
import DataGridCellSelector from './data-grid-cell-selector.component';
import type { DataGridCellRenderer } from './data-grid-custom-column.interface';
import type { DataGridColumnSettings } from './data-grid-settings.interface';

export interface DataGridDataRowItemProps {
  item: JsonDataItem;
  column: DataGridColumnSettings;
  components?: Record<string, DataGridCellRenderer>;
  allowCellScrollBar?: boolean;
  rowId?: string;
  onMeasured?: (columnId: string, width: number, rowId?: string) => void;
  isSizingActive?: boolean;
}

export default function DataGridDataRowItem({
  item,
  column,
  components,
  allowCellScrollBar,
  rowId,
  onMeasured,
  isSizingActive,
}: DataGridDataRowItemProps) {
  const ref = useRef<HTMLDivElement>(null);
  // NOTE: if modifying the margin 'mr-3', please remember to update 'CELL_RIGHT_MARGIN_PX'
  const cellClasses = clsx('box-content mr-3', {
    'h-9 truncate py-px leading-9': !allowCellScrollBar,
    'h-auto leading-none overflow-y-auto content-center': allowCellScrollBar,
  });

  return (
    <div style={{ width: column.width + 'px' }} className={cellClasses}>
      <DataGridCellSelector
        ref={ref}
        item={item}
        column={column}
        components={components}
        allowCellScrollBar={allowCellScrollBar}
        rowId={rowId}
        onMeasured={onMeasured}
        isSizingActive={isSizingActive}
      />
    </div>
  );
}
